import { isFunction } from './typeof';
import Detector from './detector';

const zzc = window.zzc;
const zzcjsbridge = window.zzcjsbridge;

export function setAppRightBarList(config = {}, cb, successCb) {
  zzc && zzc.call('appCustomRightBarList', {
    customItems: [...config],
    listener(response) {
      isFunction(cb) && cb(response);
    },
    success(response) {
      isFunction(successCb) && successCb(response);
    }
  });
}

export function openKeyboard(successCb) {
  zzc && zzc.call('base_openKeyboard', {
    success(response) {
      isFunction(successCb) && successCb(response);
    }
  });
}

// 设置导航栏左边的按钮
// http://wiki.tools.zuzuche.com/pages/viewpage.action?pageId=7243724#space-menu-link-content
export function setNavBarLeftButton(config, cb, successCb) {
  const _config = {
    ...config,
    listener(response) {
      isFunction(cb) && cb(response);
    },
    success(response) {
      isFunction(successCb) && successCb(response);
    }
  };
  zzc && zzc.call('base_customNavbarLeftButton', _config);
}

// 设置导航栏右边的所有按钮
// http://wiki.tools.zuzuche.com/pages/viewpage.action?pageId=7243724#space-menu-link-content
export function setNavBarRightButtons(config, cb, successCb) {
  const _config = {
    ...config,
    listener(response) {
      isFunction(cb) && cb(response);
    },
    success(response) {
      isFunction(successCb) && successCb(response);
    }
  };
  zzc && zzc.call('base_navbarRightButtons', _config);
}

// 回到首页
// http://wiki.tools.zuzuche.com/pages/viewpage.action?pageId=4691094
export function backToHome(tabIndex = 'home', successCb) {
  window.zzc && window.zzc.call('base_backToHome', {
    tabIndex,
    success(response) {
      isFunction(successCb) && successCb(response);
    }
  });
}

// 滚动到一定位置出现navbar
// http://wiki.tools.zuzuche.com/pages/viewpage.action?pageId=7243724#space-menu-link-content
export function setSearchBarState(config, cb, successCb) {
  const _config = {
    ...config,
    listener(response) {
      isFunction(cb) && cb(response);
    },
    success(response) {
      isFunction(successCb) && successCb(response);
    }
  };
  zzc && zzc.call('base_SetSearchBarState', _config);
}

// 原生调起分享
// http://wiki.tools.zuzuche.com/pages/viewpage.action?pageId=4691098
// ios分享的链接不能有中文
// 分享的图片不能超过128k
export function setShare(config, cb, successCb) {
  const _config = {
    photo: 'https://imgcdn50.zuzuche.com/static/10/08/03814124cd32d78595198db8c7106106.png',
    shareUrl: window.location.href,
    sharePlatform: ['wxsession', 'wxtimeline', 'copy'],
    ...config,
    listener(response) {
      isFunction(cb) && cb(response);
    },
    success(response) {
      isFunction(successCb) && successCb(response);
    },
    error(err) {
      // eslint-disable-next-line
      console.log('share插件报错', err);
    }
  };
  zzc && zzc.call('base_share', _config);
}

export function setTitle(title = '旅行商城', options = {}) {
  options = { ...options, title };
  zzc && zzc.call('webviewtitle', options);
}

/**
 * 是否存在某个 API
 * @param api
 * @returns {boolean}
 */
export const hasThisApi = (api) => {
  return !!window.zzcjsbridge && !!window.zzcjsbridge[api];
};

export const callApi = (apiName, apiParams) => {
  return new Promise((resolve, reject) => {
    if (!window.zzc) {
      reject(new Error('APP environment is required!'));
      return;
    }

    const options = {
      ...apiParams,
      success: (response) => {
        console.log(apiName, response);
        if (typeof response === 'string') {
          response = JSON.parse(response);
        }

        resolve(response);
      }
    };

    window.zzc.call(apiName, options);
  });
};

export const requestLocation = (params) => {
  return callApi('base_requestLocation', params);
};

export const onPullToRefresh = (params) => {
  return callApi('base_addPullToRefresh', params);
};

export const onTabbarSelected = (params) => {
  return callApi('onTabbarSelected', params);
};

export const setTopBarStyle = (params) => {
  return callApi('base_setTopBarStyle', params);
};

export const setStatusColor = (params) => {
  return callApi('base_SetStatusColor', params);
};

export const updateWebTopSearchBar = (params) => {
  return callApi('base_updateWebTopSearchBar', params);
};

export const setTopBackBtnState = (params) => {
  return callApi('base_setTopBackBtnState', params);
};

export const storage = {
  getAllItems: (namespace) => {
    return callApi('base_localStorageAllItems', {
      namespace
    });
  },
  setItem: (namespace, key, value) => {
    return callApi('base_localStorageSetItem', {
      namespace,
      key,
      value
    });
  }
};

export const showWebActivity = (params) => {
  return callApi('showWebActivity', params);
};

export const hideWebActivity = () => {
  return callApi('hideWebActivity', {});
};

export const webActivityPageFinished = () => {
  return callApi('webActivityPageFinished', {});
};

export function getAppNarBarHeight() {
  let height;
  const dpr = window.devicePixelRatio;
  if (Detector.browser.name === 'zuzuche') {
    switch (Detector.os.name) {
      case 'android':
        try {
          const nativeNarBarH = window.zuzuche && window.zuzuche.getNotchHeight();
          height = nativeNarBarH / dpr + 46;
        } catch (error) {
          // eslint-disable-next-line
          console.error(error)
        }
        break;
      case 'ios':
        // 刘海屏的ios
        if (Detector.isIphoneXseries) {
          height = 44 + 44;
        } else {
          height = 44 + 20;
        }
        break;
      default:
        height = 0;
    }
  } else {
    height = 0;
  }
  return height;
}

export const getAppPermission = (params) => {
  return callApi('base_getAppPermission', params);
};

export const openAppSetting = (params) => {
  return callApi('base_openAppSetting', params);
};

export {
  zzc,
  zzcjsbridge
};
